let currentIndex = 0;
const track = document.querySelector('.slider-track');
const slides = document.querySelectorAll('.slide');
const dotsContainer = document.querySelector('.slider-dots');
let autoScroll = setInterval(nextSlide, 4000);
let touchStartX = 0;
let touchEndX = 0;
let isDragging = false;

// Add touch event listeners
track.addEventListener('touchstart', handleTouchStart);
track.addEventListener('touchmove', handleTouchMove);
track.addEventListener('touchend', handleTouchEnd);

// Initialize dots
slides.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.classList.add('slider-dot');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
});
const dots = document.querySelectorAll('.slider-dot');
dots[0].classList.add('active');

function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    isDragging = true;
    clearInterval(autoScroll); // Pause autoplay during interaction
    track.style.transition = 'none';
}

function handleTouchMove(e) {
    if (!isDragging) return;
    touchEndX = e.touches[0].clientX;
    const diff = touchStartX - touchEndX;
    track.style.transform = `translateX(calc(-${currentIndex * 100}% - ${diff}px))`;
}

function handleTouchEnd() {
    if (!isDragging) return;
    isDragging = false;
    track.style.transition = 'transform 0.3s ease-in-out';
    
    const diff = touchStartX - touchEndX;
    const swipeThreshold = window.innerWidth * 0.3; // 30% of screen width
    
    if (diff > swipeThreshold && currentIndex < slides.length - 1) {
        nextSlide();
    } else if (diff < -swipeThreshold && currentIndex > 0) {
        prevSlide();
    } else {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
    }
    
    // Restart autoplay
    resetInterval();
}

function updateSlide() {
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentIndex);
    });
}

function goToSlide(index) {
    currentIndex = index;
    updateSlide();
    resetInterval();
}

function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSlide();
    resetInterval();
}

function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSlide();
    resetInterval();
}

function resetInterval() {
    clearInterval(autoScroll);
    autoScroll = setInterval(nextSlide, 4000);
}

document.querySelector('.next').addEventListener('click', nextSlide);
document.querySelector('.prev').addEventListener('click', prevSlide);